package com.wintermar.inspection.feature.util.inspection_status

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import com.wintermar.inspection.core.ui.util.toTitleCase
import com.wintermar.inspection.graphql.type.InspectionStatus
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_check_circle

@Composable
fun InspectionStatus.toVariant(): InspectionStatusContentModel {
    val themeColor = LocalAppTheme.current.color

    val content = when (this) {
        InspectionStatus.IN_PROGRESS -> InspectionStatusContentModel(
            label = this.name.toTitleCase(),
            labelColor = themeColor.text.info.bolder,
            backgroundColor = themeColor.surface.semantic.info.subtle.default,
            borderColor = themeColor.border.info
        )

        InspectionStatus.COMPLETED -> InspectionStatusContentModel(
            label = this.name.toTitleCase(),
            labelColor = themeColor.text.success.bolder,
            backgroundColor = themeColor.surface.semantic.success.subtle.default,
            borderColor = themeColor.border.success
        )

        InspectionStatus.APPROVED -> InspectionStatusContentModel(
            label = this.name.toTitleCase(),
            labelColor = themeColor.text.subtle,
            iconColor = themeColor.icon.brand,
            icon = Res.drawable.ic_check_circle,
            backgroundColor = themeColor.surface.neutral.subtle.default,
            borderColor = themeColor.border.default
        )

        InspectionStatus.UNKNOWN__ -> InspectionStatusContentModel(
            label = this.name.toTitleCase(),
            labelColor = themeColor.text.default,
        )
    }

    return remember(this, themeColor) {
        content
    }
}
